import { ItfNewsItem } from './type';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import { ECOFLOW_LOGO } from './const';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';

const Card: React.FC<{ card: ItfNewsItem }> = ({ card }) => {
    const { tag, title, date, href, pc, h5 } = card;
    return (
        <EcoLink className="card" href={href}>
            <div className="card-img">
                <EcoImgVideo isVideo={pc?.endsWith('.mp4') || pc?.endsWith('.webm')} pc={pc} h5={h5} alt={title} />
            </div>
            <div className="card-info">
                <p className="card-tag">{tag}</p>
                <h3 className="card-title" title={title}>
                    {title}
                </h3>
                <div className="card-memo">
                    <div className="card-logo">
                        <EcoImg className="card-logo-icon" pc={ECOFLOW_LOGO} alt="EcoFLow" />
                        <span className="card-logo-text">{'EcoFlow'}</span>
                    </div>
                    <p className="card-date">{date}</p>
                </div>
            </div>
        </EcoLink>
    );
};

export default Card;
